import styled from 'styled-components';

import { MpText } from 'shared/ui/MpText';

export const TitleStyled = styled(`h2`)`
	margin-top: 8px;
	margin-bottom: 10px;
	font-size: 20px;
`;

export const InvoicesContainerStyled = styled.div`
	gap: 12px;
	display: flex;
	flex-direction: column;
`;

export const InvoicesAppBlockStyled = styled.div`
	gap: 36px;
	display: flex;
	flex-direction: column;
`;

export const HeadingStyled = styled.h2`
	margin-bottom: 16px;
	font-weight: 600;
	font-size: 20px;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 30px;
		margin-bottom: 24px;
	}
`;

export const MyInvoicesHeaderStyled = styled.h3`
	margin-bottom: 24px;
	font-weight: 600;
	font-size: 24px;
`;

export const TextStyled = styled(MpText)`
	margin-bottom: 24px;

	text-align: center;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 495px;
		margin-bottom: 36px;
	}
`;
